import { useEffect, useRef } from "react";

import { COOKIEBOT_ID } from "../../global/cookiebot-script";

export type CookieDeclarationProps = {
  cbid?: string;
};

export const CookieDeclaration = ({ cbid }: CookieDeclarationProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const resolvedCbid = cbid?.trim() || COOKIEBOT_ID;

  useEffect(() => {
    const container = ref.current;
    if (!container || !resolvedCbid) return;
    if (container.querySelector("#CookieDeclaration")) return;

    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = `https://consent.cookiebot.com/${resolvedCbid}/cd.js`;
    script.type = "text/javascript";
    script.async = true;
    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [resolvedCbid]);

  return <div ref={ref} className="cookie-declaration" />;
};
